(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hd-search-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.toLocaleLowerCase('tr').normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

    for (const form of document.querySelectorAll('[data-hd-filter]')) {
      if (form.dataset.hdBound) continue;
      form.dataset.hdBound = 'true';
      const input = form.querySelector('input[name="q"]');
      const empty = form.parentElement.querySelector('.hd-search__empty');

      form.addEventListener('submit', (event) => event.preventDefault());
      input.addEventListener('input', () => {
        const query = normalize(input.value);
        let visible = 0;
        for (const item of document.querySelectorAll('.resource-list__item')) {
          const match = !query || normalize(item.textContent).includes(query);
          item.toggleAttribute('data-hd-hidden', !match);
          if (match) visible += 1;
        }
        if (empty) empty.hidden = visible > 0;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
